import GeoLocation from './GeoDef';

export default { GeoLocation };
